/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { LwpProvider } from '../hooks/use-lwp';
import { LwpActionsProvider } from '../hooks/use-lwp-actions/use-lwp-actions';
import { LwpWidgetPropsProvider } from '../hooks/use-lwp-widget-props/provider';

interface LwpWidgetProvidersProps {
  children: React.ReactNode;
}

export const LwpWidgetProviders: React.FC<LwpWidgetProvidersProps> = (props) => {
  return (
    <LwpWidgetPropsProvider>
      <LwpProvider>
        <LwpActionsProvider>
          {props.children}
        </LwpActionsProvider>
      </LwpProvider>
    </LwpWidgetPropsProvider>
  )
};
